const en =  {
    pageTitle: 'Endless Friend Rewards | HKBN',
    loginLabel1: 'Please fill in your HKBN account and contact number or ',
    loginLabel2: ' to get your referral code',
    contactLabel: ' Please fill in your contact number or ',
    loginLinkLabel: 'Login to myHKBN',
    loginText: 'Login',
    accountLabel: 'HKBN Account Number',
    contactNoLabel: 'Contact Number',
    ReferralCode: 'You Referral Code',
    ReferralCodeError: 'Please enter a valid Referral Code.',
    TNC: 'Terms and Conditions',
    share: 'Share',
    copySuccess: ' Success',
    QNATitle: 'FAQ',
    HowToTitle: 'HOW-TO',
    StaticBarTextLeft: '[New Referral Program] Register with "',
    StaticBarTextRight: '" for designated plans and share up to $1,900 Account Rewards!',
    StaticBarTNC: 'Terms and conditions apply.',
};

export default en;